module.exports = __webpack_public_path__ + "static/media/Nutrition.4381bc24.svg";